const reducer = (state = '', action) =>{
    switch(action.type){
        case "setCompany": 
            return action.payload;
        default: 
            return state;
    }
}

export default reducer;  